import { render, staticRenderFns } from "./newList.vue?vue&type=template&id=68a5aac7"
import script from "./newList.vue?vue&type=script&lang=js"
export * from "./newList.vue?vue&type=script&lang=js"
import style0 from "./newList.vue?vue&type=style&index=0&id=68a5aac7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports